import Choices from 'choices.js';
import Cookies from 'js-cookie';
import { formatMoney } from "@shopify/theme-currency";

window.product = window.product || {};

const { product } = window;

product.form = (options) => {
    const moneyFormat = window.theme.moneyWithCurrencyFormat;
    const { variant } = options;
    const currentProduct = document
        .getElementById(options.selector.domIdPrefix)
        .closest('[data-product]');
    const productForm = currentProduct.querySelector('[data-product-form]');

    if (!currentProduct) {
        return;
    }

    const memberDiscount = parseFloat(productForm.dataset.memberDiscount || 0);

    const productImageWrappers = currentProduct.querySelectorAll('[data-product-image-wrapper]');
    const productSubmit = currentProduct.querySelector('[data-product-submit]');
    const productSubmitText = currentProduct.querySelector('[data-product-submit-text]');
    const productPriceElements = currentProduct.querySelectorAll('[data-product-price]');
    const productMemberPriceElements = currentProduct.querySelectorAll('[data-product-member-price]');
    const productMemberComparePriceElement = currentProduct.querySelector('[data-member-compare-price]');
    const productMemberDiscountPriceElements = currentProduct.querySelectorAll('[data-member-discount-value]');
    const comparePrice = currentProduct.querySelector('[data-product-compare-price]');
    const controlKitVariantImage = currentProduct.querySelector('[data-control-kit-variant-image]');

    if (variant) {
        const current_url_params = new URLSearchParams(window.location.search);
        current_url_params.set('variant', variant.id);
        window.history.replaceState(
            null,
            null,
            `?${current_url_params.toString()}`
        );

        if (productImageWrappers.length && variant.featured_image) {
            productImageWrappers.forEach((productImageWrapper) => {
                const wrapperImageId = parseFloat(productImageWrapper.getAttribute('data-image-id'));

                if (wrapperImageId === variant.featured_image.id) {
                    productImageWrapper.classList.remove('hide');
                } else {
                    productImageWrapper.classList.add('hide');
                }
            });
        }

        if (controlKitVariantImage) {
            controlKitVariantImage.setAttribute('src',
                variant.featured_image.src);
        }

        if (productSubmit) {
            if (variant.available) {
                productSubmit.classList.remove('disabled');
                productSubmit.removeAttribute('disabled');
                productSubmitText.innerHTML = window.theme.strings.addToBag;
            } else {
                productSubmit.classList.add('disabled');
                productSubmit.setAttribute('disabled', true);
                productSubmitText.innerHTML = window.theme.strings.soldOut;
            }
        }

        productPriceElements.forEach((productPriceElement) => {
            productPriceElement.innerHTML = formatMoney(variant.price,
                moneyFormat);
        });

        productMemberPriceElements.forEach((productPriceElement) => {
            productPriceElement.innerHTML = formatMoney((variant.price * (100 - memberDiscount)) / 100,
                moneyFormat);
        });

        productMemberDiscountPriceElements.forEach((productPriceElement) => {
            productPriceElement.innerHTML = formatMoney((variant.price * memberDiscount) / 100,
                moneyFormat);
        });

        if (comparePrice) {
            if (variant.compare_at_price > variant.price) {
                comparePrice.innerHTML = formatMoney(variant.compare_at_price,
                    moneyFormat);
                comparePrice.classList.remove('hide');

                if (productMemberComparePriceElement) {
                    productMemberComparePriceElement.innerHTML =
                        formatMoney((variant.compare_at_price *
                                (100 - memberDiscount)) /
                                100,
                        moneyFormat);
                    productMemberComparePriceElement.classList.remove('hide');
                }
            } else {
                comparePrice.classList.add('hide');

                if (productMemberComparePriceElement) {
                    productMemberComparePriceElement.classList.add('hide');
                }
            }
        }
    } else {
        productSubmit.classList.add('disabled');
        productSubmit.setAttribute('disabled', true);
        productSubmitText.innerHTML = window.theme.strings.unavailable;
    }
};

export function productSelectsInit(form) {
    const productSelects = form.querySelectorAll('select');
    const productSwatches = form.querySelector('[data-product-swatches]');

    if (!productSelects.length) {
        return;
    }

    productSelects.forEach((productSelect) => {
        if (!productSelect.hasAttribute('data-option')) {
            return;
        }

        const alsoAvailableLinks = document.querySelectorAll('[data-also-available-link]');

        if (alsoAvailableLinks.length) {
            if (window.location.href.indexOf('?style-collection=') >= 0) {
                const styleCollectionParam =
                    window.location.href.split('?style-collection=')[1];

                alsoAvailableLinks.forEach((alsoAvailableLink) => {
                    if (
                        alsoAvailableLink
                            .getAttribute('href')
                            .indexOf(styleCollectionParam) === -1
                    ) {
                        return;
                    }

                    const styleLetter =
                        alsoAvailableLink.getAttribute('data-style-letter');
                    const productSelectOptions =
                        productSelect.querySelectorAll('option');

                    if (productSelectOptions.length) {
                        productSelectOptions.forEach((productSelectOption) => {
                            const productOptionValue =
                                productSelectOption.value.split('-')[0];

                            if (
                                productOptionValue.indexOf(`${styleLetter}`) >=
                                0
                            ) {
                                return;
                            }
                            productSelectOption.remove();
                            productSelect.dispatchEvent(new Event('change'));
                        });
                    }
                });
            } else {
                alsoAvailableLinks.forEach((alsoAvailableLink) => {
                    if (!alsoAvailableLink.classList.contains('hide')) {
                        return;
                    }

                    const styleLetter =
                        alsoAvailableLink.getAttribute('data-style-letter');
                    const productSelectOptions =
                        productSelect.querySelectorAll('option');

                    if (productSelectOptions.length) {
                        productSelectOptions.forEach((productSelectOption) => {
                            const productOptionValue =
                                productSelectOption.value.split('-')[0];

                            if (
                                productOptionValue.indexOf(`${styleLetter}`) >=
                                0
                            ) {
                                return;
                            }

                            productSelectOption.remove();
                            productSelect.dispatchEvent(new Event('change'));
                        });
                    }
                });
            }
        }

        if (
            productSwatches &&
            !productSwatches.hasAttribute('data-product-swatches-links') &&
            productSelect.getAttribute('data-option') === 'option1'
        ) {
            productSelect.classList.add('hide');
        } else {
            new Choices(productSelect, {
                 
                searchEnabled: false,
                itemSelectText: '',
                placeholder: true,
                shouldSort: false,
                position: 'bottom'
            });
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const contolKitBuilder = document.querySelector('[data-control-kit-builder]');
    const form = document.querySelector('[data-product] [data-product-form]');

    if (!form || contolKitBuilder) {
        return;
    }

    productSelectsInit(form);
});

export function revertToRegularPrice() {
    const siteBody = document.body;
    if (!siteBody) {
        return false;
    }

    const active_subscriber =
        parseInt(siteBody.getAttribute('data-active-subscriber')) || 0;
    if (active_subscriber) {
        return false;
    }

    const membership_in_cart =
        parseInt(siteBody.getAttribute('data-membership-in-cart')) || 0;
    if (membership_in_cart) {
        return false;
    }

    const showMembershipPrice =
        parseInt(siteBody.getAttribute('data-show-member-pricing')) || 0;
    if (!showMembershipPrice) {
        return true;
    }

    return Boolean(parseInt(Cookies.get('add_membership_product'))) === false;
}
